import { type Common } from '../common.js';
import {
  type CopilotSession,
  type CreateValues,
  type Payload,
} from '../models/orchestrator/copilot/session.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(values: CreateValues): Promise<Payload> {
    const url = this.common.constructPath('/copilot/sessions');
    const { session, job } = await this.common.postJSON(url, values);
    return { session, job };
  }

  async findAll(
    query: {
      active?: boolean;
    } = {}
  ): Promise<CopilotSession[]> {
    const url = this.common.constructPath('/copilot/sessions', query);
    return await this.common.getJSON(url);
  }

  async destroy(id: string): Promise<void> {
    const url = this.common.constructPath(`/copilot/sessions/${id}`);
    return await this.common.deleteJSON(url);
  }

  async extend(id: string): Promise<CopilotSession> {
    const url = this.common.constructPath(`/copilot/sessions/${id}/extend`);
    return await this.common.patchJSON(url);
  }
}
